import { CLICK_PRODUCT_VIEW_SOURCE } from '@/data/constants/clickProductView';
import valueIsString from 'integration/utils/typeAssertions/valueIsString';

const CLICK_SOURCES = new Set<string>(Object.values(CLICK_PRODUCT_VIEW_SOURCE));

export const isValidClickProductView = (clickSource: unknown) => {
	if (!valueIsString(clickSource)) {
		return false;
	}

	return CLICK_SOURCES.has(clickSource);
};
